import { Component, Inject, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { CriticalDate } from '../../../objects/critical-dates';
import { PermissionsStoreService } from '../../../service/permissions/permissions-store.service';

export interface CriticalDateActionsDialogData {
  criticalDate: CriticalDate;
  hasEntityLink: boolean;
}

@Component({
  selector: 'app-critical-date-actions-dialog',
  templateUrl: './critical-date-actions-dialog.component.html',
  styleUrls: ['./critical-date-actions-dialog.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class CriticalDateActionsDialogComponent {
  private permissionsStore = inject(PermissionsStoreService);
  isViewer = this.permissionsStore.isViewer;

  constructor(
    public dialogRef: MatDialogRef<CriticalDateActionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CriticalDateActionsDialogData
  ) {}

  onEditClick(): void {
    this.dialogRef.close('edit');
  }

  onGoToItemClick(): void {
    this.dialogRef.close('goto');
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }
}
